<template>
    <div class="o-w-tile-placeholder w-tile-placeholder">
        <ContentLoader
            :width="375"
            :height="79"
            preserveAspectRatio="xMidYMid meet"
            primaryColor="#d1d1d1"
        >
            <rect 
                x="16"
                y="30"
                rx="0" 
                ry="0" 
                width="30"
                height="30"
            />
            <rect 
                x="60"
                y="30"
                rx="0" 
                ry="0" 
                width="150"
                height="10"
            />
            <rect
                x="60"
                y="50"
                rx="0"
                ry="0"
                width="100"
                height="10"
            />
            <rect
                x="280"
                y="30"
                rx="0"
                ry="0"
                width="80"
                height="30"
            />
        </ContentLoader >
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
    
export default {
    name: 'OWTilePlaceholder',
    components: {
        ContentLoader
    }
}
</script>

<style lang="scss">
@import "o-w-tile-placeholder";
</style>